module.exports = __webpack_public_path__ + "72c1cc9c7df246462184c5b735364876.pdf";